import { Box, Typography } from '@mui/material';

export function HeroSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        textAlign: 'center',
        py: { xs: 8, sm: 12, md: 16 },
        minHeight: { xs: 350, sm: 400, md: 500 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'url(/img/IMG_20250902_060856.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.5))',
          zIndex: 1,
        },
      }}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 2,
          textAlign: 'center',
          maxWidth: 900,
          px: 3,
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontWeight: 600,
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem' },
            color: 'text.primary',
            mb: 2,
            lineHeight: 1.2,
            textShadow: '0 2px 8px rgba(255, 255, 255, 0.8)',
          }}
        >
          Mgr. Hana Jarkovská
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
            fontWeight: 400,
            color: 'text.secondary',
            textShadow: '0 1px 4px rgba(255, 255, 255, 0.9)',
            letterSpacing: '0.02em',
          }}
        >
          Psychoterapie • Etopedické poradenství
        </Typography>
      </Box>
    </Box>
  );
}
